var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlusFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38312 0 0 5.38312 0 12C0 18.6169 5.38312 24 12 24C18.6169 24 24 18.6169 24 12C24 5.38312 18.6169 0 12 0ZM17.25 12.9998H12.9998V17.25C12.9998 17.8022 12.5522 18.2498 12 18.2498C11.4478 18.2498 11.0002 17.8022 11.0002 17.25V12.9998H6.75C6.19781 12.9998 5.75016 12.5522 5.75016 12C5.75016 11.4478 6.19781 11.0002 6.75 11.0002H11.0002V6.75C11.0002 6.19781 11.4478 5.75016 12 5.75016C12.5522 5.75016 12.9998 6.19781 12.9998 6.75V11.0002H17.25C17.8022 11.0002 18.2498 11.4478 18.2498 12C18.2498 12.5522 17.8022 12.9998 17.25 12.9998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusFill);
export default __webpack_public_path__ + "static/media/circle-plus-fill.55a27842.svg";
export { ForwardRef as ReactComponent };